import * as yup from "yup";

export const userEditFieldsConfig = {
  fullname: {
    label: "Nama Lengkap",
    type: "text",
    required: true,
    placeholder: "Nama Lengkap",
    schema: yup.string().required("Nama Lengkap wajib diisi"),
  },
  email: {
    label: "Email",
    type: "email",
    required: true,
    placeholder: "Email",
    schema: yup.string().email("Email tidak valid").required("Email wajib diisi"),
  },
  phone_number: {
    label: "No. HP",
    type: "text",
    required: true,
    placeholder: "628xx",
    schema: yup
      .string()
      .required("Nomor HP wajib diisi")
      .matches(/^62[0-9]{9,13}$/, "Harus diawali 62 dan panjang minimal 11 digit"),
  },
  profile_picture: {
    label: "Profile Picture",
    type: "file",
    required: false,
    placeholder: "Upload image",
    schema: yup
      .mixed()
      .nullable()
      .test("fileType", "Hanya file gambar yang diperbolehkan", (value: any) => {
        if (!value?.[0]) return true; // boleh kosong
        return ["image/jpeg", "image/png", "image/jpg"].includes(value[0].type);
      })
  },
  role: {
    label: "Role",
    type: "select",
    required: true,
    placeholder: "Pilih Role",
    schema: yup.string().required("Role wajib diisi"),
  },
  nik: {
    label: "NIK",
    type: "text",
    required: true,
    placeholder: "NIK",
    schema: yup
      .string()
      .required("NIK wajib diisi")
      .matches(/^[0-9]{16}$/, "NIK harus 16 digit angka"),
  },
  address: {
    label: "Alamat",
    type: "textarea",
    required: false,
    placeholder: "Alamat lengkap",
    schema: yup.string().nullable(),
  },
  profession: {
    label: "Pekerjaan",
    type: "text",
    required: false,
    placeholder: "Pekerjaan",
    schema: yup.string().nullable(),
  },
  bio: {
    label: "Bio",
    type: "textarea",
    required: false,
    placeholder: "Ceritakan tentang dirimu",
    schema: yup.string().nullable(),
  },
  password: {
    label: "Password",
    type: "password",
    required: false,
    placeholder: "Kosongkan jika tidak diubah",
    schema: yup.string().nullable().transform((value) => (value === "" ? null : value))
      .test("password-rules", "Minimal 8 karakter dan harus mengandung angka", function (value) {
        if (!value) return true; // skip validasi kalau kosong
        const hasMinLength = value.length >= 8;
        const hasNumber = /\d/.test(value);
        return hasMinLength && hasNumber;
      }),
  },
};

export const userAddFieldsConfig = {
  fullname: {
    label: "Nama Lengkap",
    type: "text",
    required: true,
    placeholder: "Nama Lengkap",
    schema: yup.string().required("Nama Lengkap wajib diisi"),
  },
  email: {
    label: "Email",
    type: "email",
    required: true,
    placeholder: "Email",
    schema: yup.string().email("Email tidak valid").required("Email wajib diisi"),
  },
  phone_number: {
    label: "No. HP",
    type: "text",
    required: true,
    placeholder: "628xx",
    schema: yup
      .string()
      .required("Nomor HP wajib diisi")
      .matches(/^62[0-9]{9,13}$/, "Harus diawali 62 dan panjang minimal 11 digit"),
  },
  profile_picture: {
    label: "Profile Picture",
    type: "file",
    required: false,
    placeholder: "Upload image",
    schema: yup
      .mixed()
      .nullable()
      .test("fileType", "Hanya file gambar yang diperbolehkan", (value: any) => {
        if (!value?.[0]) return true; // boleh kosong
        return ["image/jpeg", "image/png", "image/jpg"].includes(value[0].type);
      }),
  },
  role: {
    label: "Role",
    type: "select",
    required: true,
    placeholder: "Pilih Role",
    schema: yup.string().required("Role wajib diisi"),
  },
  nik: {
    label: "NIK",
    type: "text",
    required: true,
    placeholder: "NIK",
    schema: yup
      .string()
      .required("NIK wajib diisi")
      .matches(/^[0-9]{16}$/, "NIK harus 16 digit angka"),
  },
  address: {
    label: "Alamat",
    type: "textarea",
    required: false,
    placeholder: "Alamat lengkap",
    schema: yup.string().nullable(),
  },
  profession: {
    label: "Pekerjaan",
    type: "text",
    required: false,
    placeholder: "Pekerjaan",
    schema: yup.string().nullable(),
  },
  bio: {
    label: "Bio",
    type: "textarea",
    required: false,
    placeholder: "Ceritakan tentang dirimu",
    schema: yup.string().nullable(),
  },
  password: {
    label: "Password",
    type: "password",
    required: false,
    placeholder: "Kosongkan jika tidak diubah",
    schema: yup
      .string()
      .nullable()
      .transform((value) => (value === "" ? null : value))
      .test("password-rules", "Minimal 8 karakter dan harus mengandung angka", function (value) {
        if (!value) return true; // skip validasi kalau kosong
        const hasMinLength = value.length >= 8;
        const hasNumber = /\d/.test(value);
        return hasMinLength && hasNumber;
      }),
  },
  password_confirmation: {
    label: "Konfirmasi Password",
    type: "password",
    required: false,
    placeholder: "Ulangi password",
    schema: yup
      .string()
      .nullable()
      .transform((value) => (value === "" ? null : value))
      .oneOf([yup.ref("password"), null], "Konfirmasi password tidak cocok"),
  },
};


const schemaShape = Object.fromEntries(
  Object.entries(userEditFieldsConfig).map(([key, val]) => [key, val.schema])
);

export const userEditSchema = yup.object().shape(schemaShape);

export const userFields = Object.entries(userEditFieldsConfig);

export const userAddFields = Object.entries(userAddFieldsConfig);

export type UserEditFormValues = yup.InferType<typeof userEditSchema>;

export function getResetPayloadFromConfig(data: Record<string, any>) {
  return Object.keys(userEditFieldsConfig).reduce((acc, key) => {
    acc[key] = data?.[key] ?? "";
    return acc;
  }, {} as Record<string, any>);
}